export default __webpack_public_path__ + "static/1-7cb1924cb055f23e1a68730a8babf3d2.jpg";